import { Routes } from '@angular/router';
import { MainComponent } from './main/main.component';
export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      { path: '', redirectTo: '/search', pathMatch: 'full' },
      {
        path: 'search',
        loadComponent: () => import('./search/search.component').then((m) => m.SearchComponent),
        // canActivate: [AngularFireAuthGuard],
        // data: { authGuardPipe: redirectUnauthorizedToLogin },
      },
      {
        path: 'conversation-history',
        loadComponent: () => import('./history/history.component').then((m) => m.HistoryComponent),
        // canActivate: [AngularFireAuthGuard],
        // data: { authGuardPipe: redirectUnauthorizedToLogin },
      },
            {
        path: 'documents-history',
        loadComponent: () => import('./history-documents/history-documents').then((m) => m.HistoryDocuments),
        // canActivate: [AngularFireAuthGuard],
        // data: { authGuardPipe: redirectUnauthorizedToLogin },
      },
      {
        path: 'conversation-history/:id',
        loadComponent: () => import('./history-conversation/history-conversation.component').then((m) => m.HistoryConversationComponent),
        // canActivate: [AngularFireAuthGuard],
        // data: { authGuardPipe: redirectUnauthorizedToLogin },
      },
    ],
  },


  { path: '**', redirectTo: '' },
];
